'use client';
export const i18nText: any = {
    en: {
        region_north_america: 'North America',
        region_europe: 'Europe',
        region_asia_pacific: 'Asia Pacific',
        region_latin: 'Latin America',
        region_africa_middleeast: 'Africa & Middle East',
        region_global: 'Global',

        title: 'Choose your country or region',
        region_other: 'Other',
        region_europe_ad: 'Authorized Distributor',
        comming_soon: '(coming soon)',
    },
    cis: {
        region_europe: 'Европа',
        comming_soon: '(вскоре)',
        title: 'Выберите свою страну или регион',
        region_asia_pacific: 'Азиатско-Тихоокеанский регион',
        region_other: 'Другой',
        region_north_america: 'Северная Америка',
        region_africa_middleeast: 'Африка и Ближний Восток',
        region_europe_ad: 'Authorized Distributor',
        region_latin: 'Latin America',

        region_global: 'Global',
    },
    cn: {
        region_europe: '欧洲',
        comming_soon: '(即将到来)',
        title: '选择您的国家或地区',
        region_asia_pacific: '亚太地区',
        region_other: '其他',
        region_north_america: '北美',
        region_africa_middleeast: '非洲和中东',
        region_europe_ad: 'Authorized Distributor',
        region_latin: '拉丁美洲',

        region_global: '全球',
    },
    de: {
        region_europe: 'Europa',
        comming_soon: '(kommt bald)',
        title: 'Wählen Sie Ihr Land oder Ihre Region',
        region_asia_pacific: 'Asien-Pazifik',
        region_other: 'Sonstiges',
        region_north_america: 'Nordamerika',
        region_africa_middleeast: 'Afrika und Naher Osten',
        region_europe_ad: 'Autorisierter Distributor',
        region_latin: 'Lateinamerika',
        region_global: 'Global',
    },
    es: {
        region_europe: 'Europa',
        comming_soon: '(Viene)',
        title: 'Selecciona tu país o región',
        region_asia_pacific: 'Asia-Pacífico',
        region_other: 'Otro',
        region_north_america: 'Norteamérica',
        region_africa_middleeast: 'África y Oriente Medio',
        region_europe_ad: 'Distribuidor autorizado',
        region_latin: 'América Latina',
        region_global: 'Global',
    },
    fr: {
        region_europe: 'Europe',
        comming_soon: '(À VENIR)',
        title: 'Choisissez votre pays ou région',
        region_asia_pacific: 'Asie-Pacifique',
        region_other: 'Autres',
        region_north_america: 'Amérique du Nord',
        region_africa_middleeast: 'Afrique et Moyen-Orient',
        region_europe_ad: 'Distributeur agréé',
        region_latin: "l'Amérique latine",
        region_global: 'Global',
    },
    it: {
        region_europe: 'Europa',
        comming_soon: '(in arrivo presto)',
        title: 'Scegli il paese o la regione',
        region_asia_pacific: 'Asia Pacifico',
        region_other: 'Altro',
        region_north_america: 'Nord America',
        region_africa_middleeast: 'Africa e Medio Oriente',
        region_europe_ad: 'Distributore autorizzato',
        region_latin: 'America Latina',
        region_global: 'Global',
    },
    jp: {
        region_europe: '欧州',
        comming_soon: '(すぐに始まる)',
        title: '国または地域の選択',
        region_asia_pacific: 'アジア太平洋',
        region_other: 'その他',
        region_north_america: '北米',
        region_africa_middleeast: 'アフリカおよび中東',
        region_europe_ad: 'Authorized Distributor',
        region_latin: 'ラテンアメリカ',
        region_global: 'Global',
    },
    kr: {
        region_europe: '유럽',
        comming_soon: '(곧 지원 예정)',
        title: '국가 또는 지역 선택',
        region_asia_pacific: '아시아 태평양',
        region_other: '기타',
        region_north_america: '북미',
        region_africa_middleeast: '아프리카 및 중동',
        region_europe_ad: 'Authorized Distributor',
        region_latin: '라틴 아메리카',
        region_global: 'Global',
    },
    sa: {
        region_other: 'أخرى',
        region_africa_middleeast: 'إفريقيا والشرق الأوسط',
        region_europe: 'أوروبا',
        title: 'حدد بلدك أو منطقتك',
        comming_soon: '(قريبًا)',
        region_north_america: 'أمريكا الشمالية',
        region_asia_pacific: 'آسيا والمحيط الهادئ',
        region_europe_ad: 'Authorized Distributor',
        region_latin: 'أمريكا اللاتينية',
        region_global: 'Global',
    },
    tw: {
        comming_soon: '（即將到來）',
        title: '選擇您的國家或地區',
        region_asia_pacific: '亞太地區',
        region_north_america: '北美',
        region_europe: '歐洲',
        region_africa_middleeast: '非洲和中東',
        region_other: '其他',
        region_europe_ad: 'Authorized Distributor',
        region_latin: '拉丁美洲',
        region_global: 'Global',
    },
    pl: {
        region_europe: 'Europe',
        comming_soon: '(coming soon)',
        title: 'Choose your country or region',
        region_asia_pacific: 'Asia Pacific',
        region_other: 'Other',
        region_north_america: 'North America',
        region_africa_middleeast: 'Africa & Middle East',
        region_europe_ad: 'autoryzowany dystrybutor',
        region_latin: 'Latin America',
        region_global: 'Global',
    },
    br: {
        region_europe: 'Europa',
        comming_soon: '(em breve)',
        title: 'Escolha seu país ou região',
        region_asia_pacific: 'Ásia-Pacífico',
        region_other: 'Outro',
        region_north_america: 'América do Norte',
        region_africa_middleeast: 'África e Oriente Médio',
        region_europe_ad: 'Distribuidor autorizado',
        region_latin: 'América latina',
        region_global: 'Global',
    },
    mx: {
        region_europe: 'Europa',
        comming_soon: '(Viene)',
        title: 'Selecciona tu país o región',
        region_asia_pacific: 'Asia-Pacífico',
        region_other: 'Otro',
        region_north_america: 'Norteamérica',
        region_africa_middleeast: 'África y Oriente Medio',
        region_europe_ad: 'Distribuidor autorizado',
        region_latin: 'América Latina',
        region_global: 'Global',
    },
    nl: {
        region_europe: 'Europa',
        comming_soon: '(binnenkort verkrijgbaar)',
        title: 'Kies uw land of regio',
        region_asia_pacific: 'Azië-Pacific',
        region_other: 'Ander',
        region_north_america: 'Noord-Amerika',
        region_africa_middleeast: 'Afrika en het Midden-Oosten',
        region_europe_ad: 'Geautoriseerde distributeur',
        region_latin: 'Latijns-Amerika',
        region_global: 'Global',
    },
};
